import { Injectable } from '@angular/core';
import { OfflineManagerService } from './offline-manager.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { NetworkService, ConnectionStatus } from './network.service';
import { Storage } from '@ionic/storage';
import { Observable, from } from 'rxjs';
import { tap, map, catchError } from "rxjs/operators";
import { Router } from '@angular/router';
import { ToastController, Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
 
const API_STORAGE_KEY = 'specialkey';
const API_URL = 'http://196.43.133.103:8080/api/';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  authState = new BehaviorSubject(false);

  constructor(private http: HttpClient,
    private networkService: NetworkService,
    private storage: Storage,
    private router: Router,
    private platform: Platform,
    public toastController: ToastController,
    private offlineManager: OfflineManagerService) {
    //Start of constructor
    this.platform.ready().then(() => {
      this.ifLoggedIn();
    });
    // EOC
   }
  getRecord(forceRefresh: boolean = false,endpoint,data_key): Observable<any[]> {
    if (this.networkService.getCurrentNetworkStatus() == ConnectionStatus.Offline || !forceRefresh) {
      this.storage.create();
      // Return the cached data from Storage
      return from(this.getLocalData(data_key));
    } else {

    this.storage.create();
    return this.http.get(API_URL+endpoint).pipe(
     map(res => res['data']),
     tap(res => {
       this.setLocalData(data_key, res);
     })
   )    
       // My Return
    }
  }
 
  updateUser(user, data): Observable<any> {
    let url = `${API_URL}/users/${user}`;
    if (this.networkService.getCurrentNetworkStatus() == ConnectionStatus.Offline) {
      return from(this.offlineManager.storeRequest(url, 'PUT', data));
    } else {
      return this.http.put(url, data).pipe(
        catchError(err => {
          this.offlineManager.storeRequest(url, 'PUT', data);
          throw new Error(err);
        })
      );
    }
  }
 
   //
  addRecord(url,data): Observable<any> {
    //this.storage.create();
    
    if (this.networkService.getCurrentNetworkStatus() == ConnectionStatus.Offline) {
      return from(this.offlineManager.storeRequest(url, 'POST', data));

    } else {
      return this.http.post(url, data).pipe(
        catchError(err => {
          console.log(err);
           this.offlineManager.storeRequest(url, 'POST', data);
          throw new Error(err);
        })
      );
    }
  }


  // Save result of API requests
  private setLocalData(key, data) {
    this.storage.set(`${API_STORAGE_KEY}-${key}`, data);
  }
 
  // Get cached API result
  private getLocalData(key) {
    return this.storage.get(`${API_STORAGE_KEY}-${key}`);
  }
  // LOging Methods
  ifLoggedIn() {
    this.storage.get('USER_INFO').then((response) => {
      if (response) {
        this.authState.next(true);
      }
    });
  }


  logout() {
    this.storage.remove('USER_INFO').then(() => {
      this.router.navigate(['/welcome']);
      this.authState.next(false);
    });
    
    this.storage.clear();
  }

  isAuthenticated() {
    return this.authState.value;
  }

  // SignUP New  User
  signup(userdata){
    let url= API_URL+"auth/local/register"
   return  this.http.post(url, userdata).pipe(
      catchError(err => {
        console.log(err);
         
        throw new Error(err.error.error.message);
      })
    );

  }
  // Add New Subscriber
  subscribe(userdata){
    let url= API_URL+"subscribers"
   return  this.http.post(url, userdata).pipe(
      catchError(err => {
        console.log(err);
         
        throw new Error(err);
      })
    );

  }
  // Get User from Strapi 
  GetUser(userdata){
    let url= API_URL+"auth/local"
   return  this.http.post(url, userdata).pipe(

      catchError(err => {
        // console.log('Service Error: ',err.error.error.message);
         
        throw new Error(err.error.error.message);
      })
    );

  }
  // Login User
  login(profile){
    
    this.storage.set('USER_INFO', profile).then((response) => {
      this.authState.next(true);
      this.router.navigate(['/account']);
      // console.log('Logged in User is',this.storage.get('USER_INFO'));
    });

  }

  

}
// a8d7a9f15bebc0d3772c3a497afda6546d0941525a8880a74e284bee4df55a1ebb5b21793e6d3a9179dbc44af9cbb0096a0727660535d2eb9543c6e040632829bbdb8eb98b1cec77084459f6054f5f4e057ed878592986abba1323340746bfe840f685664db927432dd33bd2f4bd777b649e3f303947100e5ca2367cb01954e0